/**
 * ONLY RASGULLA — theme script
 * Dependency-free. Progressive enhancement over native Shopify forms:
 * every form still works without JavaScript.
 *
 * Modules: drawers (menu / search / cart), product gallery, variant picker,
 * quantity inputs, AJAX add-to-cart + cart drawer (Section Rendering API),
 * cart page auto-update, minimum order value guard, misc helpers.
 */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var routes = theme.routes;
  var strings = theme.strings;

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ------------------------------------------------------------------ */
  /* Drawers                                                             */
  /* ------------------------------------------------------------------ */
  var overlay = $('[data-page-overlay]');
  var activeDrawer = null;
  var lastFocus = null;

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function openDrawer(drawer, opener) {
    if (!drawer) return;
    if (activeDrawer && activeDrawer !== drawer) closeDrawer(activeDrawer, false);
    lastFocus = opener || document.activeElement;
    drawer.classList.add('is-open');
    activeDrawer = drawer;
    document.body.classList.add('is-locked');
    if (overlay) overlay.hidden = false;
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    window.setTimeout(function () {
      var target = $('input[type="search"]', drawer) || $(FOCUSABLE, drawer) || drawer;
      target.focus();
    }, 60);
  }

  function closeDrawer(drawer, restoreFocus) {
    drawer = drawer || activeDrawer;
    if (!drawer) return;
    drawer.classList.remove('is-open');
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (activeDrawer === drawer) activeDrawer = null;
    if (!activeDrawer) {
      document.body.classList.remove('is-locked');
      if (overlay) overlay.hidden = true;
    }
    if (restoreFocus !== false && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')), opener);
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-page-overlay]')) {
      closeDrawer();
      return;
    }
    var cartToggle = e.target.closest('[data-cart-toggle]');
    if (cartToggle && theme.cartType === 'drawer' && $('[data-cart-drawer]')) {
      e.preventDefault();
      openDrawer($('[data-cart-drawer]'), cartToggle);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!activeDrawer) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    // Keep focus inside the open drawer.
    var items = $$(FOCUSABLE, activeDrawer).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Close desktop dropdowns when clicking elsewhere.
  document.addEventListener('click', function (e) {
    $$('[data-dropdown][open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  // Close the mobile menu when switching to desktop width.
  var desktopQuery = window.matchMedia && window.matchMedia('(min-width: 990px)');
  var onBreakpoint = function (q) {
    if (q.matches && activeDrawer && activeDrawer.id === 'MenuDrawer') closeDrawer(activeDrawer, false);
  };
  if (desktopQuery && desktopQuery.addEventListener) desktopQuery.addEventListener('change', onBreakpoint);

  /* ------------------------------------------------------------------ */
  /* Quantity inputs                                                     */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('[data-quantity]');
    var input = wrap && $('input', wrap);
    if (!input) return;
    var min = parseInt(input.min, 10);
    if (isNaN(min)) min = 1;
    var next = (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty-change'), 10);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------------ */
  /* Product gallery                                                     */
  /* ------------------------------------------------------------------ */
  function showMedia(gallery, mediaId) {
    if (!gallery || !mediaId) return;
    var slide = $('[data-media-id="' + mediaId + '"]', gallery);
    if (!slide) return;
    $$('.gallery__slide', gallery).forEach(function (s) { s.hidden = s !== slide; });
    $$('[data-thumb]', gallery).forEach(function (t) {
      var active = t.getAttribute('data-thumb') === String(mediaId);
      t.classList.toggle('is-active', active);
      if (active) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
    // Pause any video that is no longer visible.
    $$('video', gallery).forEach(function (v) { if (v.closest('[hidden]')) v.pause(); });
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    showMedia(thumb.closest('[data-gallery]'), thumb.getAttribute('data-thumb'));
  });

  /* ------------------------------------------------------------------ */
  /* Variant picker                                                      */
  /* ------------------------------------------------------------------ */
  function initShowcase(root) {
    var json = $('[data-variants-json]', root);
    if (!json) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (err) { return; }

    var form = $('[data-product-form]', root);
    if (!form) return;
    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add-button]', form);
    var addText = $('[data-add-text]', form);
    var availability = $('[data-availability]', root);
    var availabilityText = $('[data-availability-text]', root);
    var priceEl = $('[data-price]', root);
    var compareEl = $('[data-compare-price]', root);
    var priceWrap = $('[data-price-wrapper]', root);
    var gallery = $('[data-gallery]', root);
    var updateUrl = root.getAttribute('data-update-url') === 'true';

    function selectedOptions() {
      return $$('fieldset[data-option-index]', form).map(function (fs) {
        var checked = $('input[data-option-input]:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = options.every(function (val, idx) { return v.options[idx] === val; });
        if (match) return v;
      }
      return null;
    }

    function update() {
      var variant = findVariant(selectedOptions());

      if (!variant) {
        idInput.disabled = true;
        addBtn.disabled = true;
        addText.textContent = strings.unavailable;
        if (availability) availability.classList.add('availability--out');
        if (availabilityText) availabilityText.textContent = strings.unavailable;
        return;
      }

      idInput.disabled = false;
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addText.textContent = variant.available ? strings.addToCart : strings.soldOut;

      if (availability) availability.classList.toggle('availability--out', !variant.available);
      if (availabilityText) availabilityText.textContent = variant.available ? strings.inStock : strings.outOfStock;

      if (priceEl) priceEl.innerHTML = variant.price;
      if (compareEl) {
        compareEl.innerHTML = variant.compare || '';
        compareEl.hidden = !variant.compare;
      }
      if (priceWrap) priceWrap.classList.toggle('price--on-sale', !!variant.compare);

      if (variant.media) showMedia(gallery, variant.media);

      if (updateUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      var error = $('[data-form-error]', form);
      if (error) error.hidden = true;
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input]')) update();
    });
  }

  $$('[data-product-showcase]').forEach(initShowcase);

  // Re-initialise sections when edited in the Theme Editor.
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-product-showcase]', e.target).forEach(initShowcase);
  });

  /* ------------------------------------------------------------------ */
  /* Cart: AJAX add + drawer refresh                                     */
  /* ------------------------------------------------------------------ */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.hidden = count === 0;
      var visible = $('[aria-hidden="true"]', el);
      if (visible) visible.textContent = count;
    });
  }

  function renderCartDrawer(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = $('[data-cart-drawer-inner]', doc);
    var current = $('[data-cart-drawer-inner]');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  function requestJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      credentials: 'same-origin'
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          var err = new Error(data.description || data.message || strings.cartError);
          throw err;
        }
        return data;
      });
    });
  }

  function refreshCartState(sectionsFromResponse) {
    renderCartDrawer(sectionsFromResponse);
    return fetch(routes.cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); return cart; })
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    // Page-mode carts fall back to Shopify's native form post (redirects to /cart).
    if (theme.cartType !== 'drawer' || !$('[data-cart-drawer]') || !window.fetch) return;
    e.preventDefault();

    var btn = $('[data-add-button]', form);
    var label = $('[data-add-text]', form);
    var error = $('[data-form-error]', form);
    var originalText = label ? label.textContent : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    if (label) label.textContent = strings.adding;
    if (error) error.hidden = true;

    var formData = new FormData(form);
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);

    fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
      credentials: 'same-origin'
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) throw new Error(data.description || data.message || strings.cartError);
          return data;
        });
      })
      .then(function (data) {
        return refreshCartState(data.sections).then(function () {
          openDrawer($('[data-cart-drawer]'), btn);
        });
      })
      .catch(function (err) {
        if (error) { error.textContent = err.message || strings.cartError; error.hidden = false; }
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        if (label) label.textContent = originalText;
      });
  });

  // Quantity +/- and remove inside the cart drawer.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-change]');
    if (!btn) return;
    e.preventDefault();
    var drawer = $('[data-cart-drawer-inner]');
    if (drawer) drawer.classList.add('is-loading');
    requestJSON(routes.cartChange + '.js', {
      line: parseInt(btn.getAttribute('data-line'), 10),
      quantity: Math.max(0, parseInt(btn.getAttribute('data-cart-change'), 10)),
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    })
      .then(function (cart) {
        renderCartDrawer(cart.sections);
        updateCartCount(cart.item_count);
      })
      .catch(function (err) { window.alert(err.message || strings.cartError); })
      .finally(function () {
        var d = $('[data-cart-drawer-inner]');
        if (d) d.classList.remove('is-loading');
        var closeBtn = $('[data-cart-drawer] [data-drawer-close]');
        if (activeDrawer && closeBtn && !activeDrawer.contains(document.activeElement)) closeBtn.focus();
      });
  });

  /* ------------------------------------------------------------------ */
  /* Cart page: submit native form when quantities change                */
  /* ------------------------------------------------------------------ */
  var cartForm = $('[data-cart-form]');
  if (cartForm) {
    var cartTimer;
    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-qty]')) return;
      // Hold checkout until the page reloads with the new subtotal (see the minimum order guard).
      var checkoutArea = $('[data-cart-checkout]', cartForm);
      if (checkoutArea) checkoutArea.setAttribute('data-checkout-pending', '');
      window.clearTimeout(cartTimer);
      cartTimer = window.setTimeout(function () {
        cartForm.classList.add('is-loading');
        var update = document.createElement('input');
        update.type = 'hidden';
        update.name = 'update';
        update.value = '1';
        cartForm.appendChild(update);
        cartForm.submit();
      }, 450);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Minimum order value: hold checkout until the cart qualifies         */
  /* ------------------------------------------------------------------ */
  // snippets/cart-checkout renders [data-checkout-blocked] from the live cart subtotal. These
  // listeners run on window in the capture phase, before any app's handlers, so they also stop
  // app checkout buttons (Shiprocket) and clicks made while a cart update is still in flight.
  function heldCheckoutArea(el) {
    var area = el && el.closest && el.closest('[data-cart-checkout]');
    if (!area) return null;
    var held = area.hasAttribute('data-checkout-blocked') || area.hasAttribute('data-checkout-pending') || area.closest('.is-loading');
    return held ? area : null;
  }

  function holdCheckout(e, area) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var notice = $('[data-cart-minimum]', area.parentNode);
    if (!notice) return;
    notice.classList.remove('is-flash');
    void notice.offsetWidth; // restart the animation
    notice.classList.add('is-flash');
  }

  window.addEventListener('click', function (e) {
    var area = heldCheckoutArea(e.target);
    if (area) holdCheckout(e, area);
  }, true);

  window.addEventListener('submit', function (e) {
    if (!e.submitter || e.submitter.name !== 'checkout') return;
    var area = heldCheckoutArea(e.submitter);
    if (area) holdCheckout(e, area);
  }, true);

  /* ------------------------------------------------------------------ */
  /* Accordion groups: one-open-at-a-time and smooth open/close          */
  /* Opt-in via data-accordion-single / data-accordion-animate on the    */
  /* element wrapping the <details>. Native <details> keeps keyboard     */
  /* (Enter/Space) and screen-reader expanded state working.            */
  /* ------------------------------------------------------------------ */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setAccordion(details, open, animate) {
    var content = $('.accordion__content', details);
    if (!animate || !content || !content.animate) { details.open = open; return; }
    if (open) {
      details.open = true;
      content.animate([{ height: '0px', opacity: 0 }, { height: content.scrollHeight + 'px', opacity: 1 }], { duration: 260, easing: 'ease-out' });
    } else {
      var closing = content.animate([{ height: content.scrollHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 200, easing: 'ease-in' });
      closing.onfinish = function () { details.open = false; };
    }
  }

  document.addEventListener('click', function (e) {
    var summary = e.target.closest('summary');
    if (!summary) return;
    var details = summary.parentElement;
    var group = details && details.parentElement;
    if (!group || !(group.hasAttribute('data-accordion-single') || group.hasAttribute('data-accordion-animate'))) return;
    e.preventDefault();
    var animate = group.hasAttribute('data-accordion-animate') && !reduceMotion;
    var opening = !details.open;
    if (opening && group.hasAttribute('data-accordion-single')) {
      $$('details[open]', group).forEach(function (other) {
        if (other !== details && other.parentElement === group) setAccordion(other, false, animate);
      });
    }
    setAccordion(details, opening, animate);
  });

  /* ------------------------------------------------------------------ */
  /* Media page: lightbox / video modal and category filters             */
  /* Triggers: [data-media-open] inside a [data-media-group].            */
  /* ------------------------------------------------------------------ */
  var mediaDialog = null;
  var mediaItems = [];
  var mediaIndex = 0;
  var mediaOpener = null;

  function buildMediaDialog() {
    var d = document.createElement('dialog');
    d.className = 'media-lightbox';
    d.setAttribute('aria-label', strings.mediaDialog || 'Media viewer');
    d.innerHTML =
      '<button type="button" class="media-lightbox__close" data-media-close aria-label="' + (strings.mediaClose || 'Close') + '">&times;</button>' +
      '<button type="button" class="media-lightbox__nav media-lightbox__nav--prev" data-media-step="-1" aria-label="' + (strings.mediaPrevious || 'Previous') + '">&#8249;</button>' +
      '<figure class="media-lightbox__figure"><div class="media-lightbox__stage" data-media-stage></div><figcaption class="media-lightbox__caption" data-media-caption></figcaption></figure>' +
      '<button type="button" class="media-lightbox__nav media-lightbox__nav--next" data-media-step="1" aria-label="' + (strings.mediaNext || 'Next') + '">&#8250;</button>';
    document.body.appendChild(d);
    d.addEventListener('click', function (e) {
      if (e.target === d || e.target.closest('[data-media-close]')) d.close();
      var step = e.target.closest('[data-media-step]');
      if (step) showMedia(mediaIndex + parseInt(step.getAttribute('data-media-step'), 10));
    });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') showMedia(mediaIndex + 1);
      if (e.key === 'ArrowLeft') showMedia(mediaIndex - 1);
    });
    d.addEventListener('close', function () {
      $('[data-media-stage]', d).innerHTML = ''; // stops any playing video
      document.body.classList.remove('is-locked');
      if (mediaOpener && mediaOpener.focus) mediaOpener.focus();
    });
    return d;
  }

  function showMedia(index) {
    if (!mediaItems.length) return;
    mediaIndex = (index + mediaItems.length) % mediaItems.length;
    var trigger = mediaItems[mediaIndex];
    var stage = $('[data-media-stage]', mediaDialog);
    var kind = trigger.getAttribute('data-kind');
    stage.innerHTML = '';
    if (kind === 'image') {
      var img = document.createElement('img');
      img.src = trigger.getAttribute('data-src');
      img.alt = trigger.getAttribute('data-alt') || '';
      img.className = 'media-lightbox__image';
      stage.appendChild(img);
    } else if (kind === 'embed') {
      var frame = document.createElement('iframe');
      frame.src = trigger.getAttribute('data-embed');
      frame.title = trigger.getAttribute('data-caption') || 'Video';
      frame.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
      frame.allowFullscreen = true;
      frame.className = 'media-lightbox__embed';
      stage.appendChild(frame);
    } else if (kind === 'video') {
      var tpl = trigger.parentElement.querySelector('template[data-media-video]');
      if (tpl) stage.appendChild(tpl.content.cloneNode(true));
    }
    stage.className = 'media-lightbox__stage media-lightbox__stage--' + kind;
    $('[data-media-caption]', mediaDialog).textContent = trigger.getAttribute('data-caption') || '';
    var multiple = mediaItems.length > 1;
    $$('[data-media-step]', mediaDialog).forEach(function (b) { b.hidden = !multiple; });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-media-open]');
    if (!trigger) return;
    var group = trigger.closest('[data-media-group]') || document;
    mediaItems = $$('[data-media-open]', group).filter(function (t) { return !t.closest('[hidden]'); });
    mediaOpener = trigger;
    if (!mediaDialog) mediaDialog = buildMediaDialog();
    showMedia(mediaItems.indexOf(trigger));
    if (typeof mediaDialog.showModal === 'function') mediaDialog.showModal(); else mediaDialog.setAttribute('open', '');
    document.body.classList.add('is-locked');
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-media-filter]');
    if (!btn) return;
    var group = btn.closest('[data-media-group]');
    var value = btn.getAttribute('data-media-filter');
    $$('[data-media-filter]', group).forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $$('.media-grid__item', group).forEach(function (item) {
      item.hidden = value !== 'all' && item.getAttribute('data-category') !== value;
    });
  });

  /* ------------------------------------------------------------------ */
  /* Media page feed: category tabs + pagination without a page reload.  */
  /* Tabs link to native blog tag URLs; we fetch the same URL through    */
  /* the Section Rendering API (section media-articles-grid) and swap    */
  /* the results. Without JS the links simply navigate.                  */
  /* ------------------------------------------------------------------ */
  function loadMediaFeed(feed, url, tabHandle, pushState) {
    var results = $('[data-media-feed-results]', feed);
    if (!results || !window.fetch) { window.location.href = url; return; }
    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=media-articles-grid';
    results.classList.add('is-loading');
    fetch(fetchUrl, { credentials: 'same-origin' })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-media-feed-results]', doc);
        if (!fresh) throw new Error('no results');
        results.innerHTML = fresh.innerHTML;
        if (tabHandle) {
          $$('[data-media-tab]', feed).forEach(function (t) {
            var on = t.getAttribute('data-media-tab') === tabHandle;
            t.classList.toggle('is-active', on);
            if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
          });
          if (pushState && window.history && window.history.replaceState) {
            var u = new URL(window.location.href);
            if (tabHandle === 'all') u.searchParams.delete('category'); else u.searchParams.set('category', tabHandle);
            u.searchParams.delete('page');
            window.history.replaceState({}, '', u.toString());
          }
        }
      })
      .catch(function () { window.location.href = url; })
      .finally(function () { results.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-media-tab]');
    var feed = e.target.closest('[data-media-feed]');
    if (!feed) return;
    if (tab) {
      e.preventDefault();
      loadMediaFeed(feed, tab.getAttribute('href'), tab.getAttribute('data-media-tab'), true);
      return;
    }
    // Pagination inside a filtered (blog tag) result: keep it in place too.
    var pageLink = e.target.closest('.pagination a');
    if (pageLink && pageLink.getAttribute('href').indexOf(feed.getAttribute('data-blog-url')) === 0) {
      e.preventDefault();
      loadMediaFeed(feed, pageLink.getAttribute('href'), null, false);
      feed.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  // Shareable links: /pages/media?category=videos opens with that tab selected.
  $$('[data-media-feed]').forEach(function (feed) {
    var wanted = new URL(window.location.href).searchParams.get('category');
    if (!wanted) return;
    var tab = $('[data-media-tab="' + wanted.replace(/"/g, '') + '"]', feed);
    if (tab) loadMediaFeed(feed, tab.getAttribute('href'), wanted, false);
  });

  /* ------------------------------------------------------------------ */
  /* Misc                                                                */
  /* ------------------------------------------------------------------ */
  // Pre-select saved country in customer address forms.
  $$('select[data-default]').forEach(function (s) {
    if (s.getAttribute('data-default')) s.value = s.getAttribute('data-default');
  });

  // Theme Editor: open the cart drawer when it is selected.
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-cart-drawer]')) openDrawer($('[data-cart-drawer]'));
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('[data-cart-drawer]')) closeDrawer(null, false);
  });
})();
